import { apiClient } from '../../utils';
import { handleError } from '../handleError';

export const createBlogAuthor = async ({ siteId, name, mobile }) => {
  try {
    const data = {
      site: siteId,
      name,
      mobile,
    };
    const rsp = await apiClient.post('/merchant/blog/createAuthor', {
      data,
    });
    return rsp;
  } catch (e) {
    handleError(e);
    throw e;
  }
};

export const editBlogAuthor = async ({ siteId, authorId, name, mobile }) => {
  try {
    const data = {
      site: siteId,
      author: authorId,
      name,
      mobile,
    };
    const rsp = await apiClient.post('/merchant/blog/editAuthor', {
      data,
    });
    return rsp;
  } catch (e) {
    handleError(e);
    throw e;
  }
};

export const deleteBlogAuthor = async ({ siteId, authorId }) => {
  try {
    const data = {
      site: siteId,
      author: authorId,
    };
    const rsp = await apiClient.post('/merchant/blog/deleteAuthor', {
      data,
    });
    return rsp;
  } catch (e) {
    handleError(e);
    throw e;
  }
};
